import { createFileRoute } from "@tanstack/react-router";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { GalleryCollectionManager } from "@/components/admin/GalleryCollectionManager";

export const Route = createFileRoute("/_authenticated/admin/gallery")({
  component: GalleryAdmin,
});

function GalleryAdmin() {
  return (
    <Tabs defaultValue="videos" className="space-y-4">
      <TabsList>
        <TabsTrigger value="videos">Videos</TabsTrigger>
        <TabsTrigger value="photos">Photos</TabsTrigger>
      </TabsList>
      <TabsContent value="videos">
        <GalleryCollectionManager
          collection="gallery-video"
          title="Gallery — Videos"
          description="Videos on the public Gallery page. New videos are added at the top. Drag to reorder, or use Sort by date. The top active video is the featured video."
          uploadBucket="gallery"
          showPermalink
          showVideo
        />
      </TabsContent>
      <TabsContent value="photos">
        <GalleryCollectionManager
          collection="gallery-photo"
          title="Gallery — Photos"
          description="Photos in the Gallery photo grid, top to bottom. New photos are added at the top. Drag to reorder, or use Sort by date."
          uploadBucket="gallery"
          showPermalink={false}
          showVideo={false}
        />
      </TabsContent>
    </Tabs>
  );
}
